import React from "react";
import { FormControl, IconButton, InputAdornment, InputLabel, MenuItem, Select, TextField } from "@material-ui/core";
import CancelPresentationIcon from "@material-ui/icons/CancelPresentation";
import styles from "./styles";
import { useTranslation } from "react-i18next";
import { textToSnakeCase, formatYYYYMMDD } from "../../../utils/utils";
import DateFnsUtils from "@date-io/date-fns";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import moment from 'moment';
import {
  Clear as ClearIcon
} from "@material-ui/icons";
import {
  fr, enUS, ar, cs, da, de, es, zhCN, nl, id, it, ja, ko, pt, ru, sv, th, tr, zhTW, fi
} from "date-fns/locale";
import { parseISO } from 'date-fns';

export const localesMap = {
  frc: fr,
  fre: fr,
  eng: enUS,
  ara: ar,
  cze: cs,
  dan: da,
  ger: de,
  spa: es,
  spl: es,
  chs: zhCN,
  dut: nl,
  ind: id,
  fil: fi,
  ita: it,
  jpn: ja,
  kor: ko,
  ptb: pt,
  rus: ru,
  swe: sv,
  tai: th,
  tur: tr,
  cht: zhTW
}

const SpecificDataRow = ({
  selectedLanguage,
  brand,
  index,
  piece,
  handleChangeSelect,
  handleChangeTextField,
  handleChangeDateField,
  removeRow,
  calibrationProfiles,
  zones,
  removeOption = true,
}) => {
  const classes = styles();
  const { t } = useTranslation();

  const handleClr = (e) => {
    handleChangeDateField(`equipment_purchase_date-${index}`, null);
    e.stopPropagation();
  }

  const handleChange = (date) => {
    handleChangeDateField(`equipment_purchase_date-${index}`, parseISO(moment(date).format(formatYYYYMMDD)))
  }

  return (
    <div
      className={classes.flexSpaceBetween}
      style={{
        borderBottom: '1px solid rgba(0,0,0,0.3)',
        margin: '10px 0',
      }}
    >
      <div
        className={classes.flexSpaceBetween}
        style={{
          width: '100%',
          alignItems: 'center',
          flexWrap: 'wrap',
        }}
      >
        <TextField
          variant="outlined"
          id={`serial_number-${index}`}
          data-testid={`serial_number-${index}`}
          label={t('restaurant.info.equipment.serialNumber')}
          name={`serial_number-${index}`}
          size="small"
          style={{ width: '300px', marginLeft: '9px' }}
          value={piece.serial_number}
          onChange={handleChangeTextField}
          error={piece.serial_number.length > 100}
          helperText={
            piece.serial_number.length > 100
              ? t('restaurant.info.equipment.lengthError')
              : ''
          }
        />
        <TextField
          variant="outlined"
          id={`alternate_name-${index}`}
          label={t('restaurant.info.equipment.alternateName')}
          name={`alternate_name-${index}`}
          required
          size="small"
          style={{ width: '300px' }}
          value={piece.alternate_name}
          onChange={handleChangeTextField}
          error={piece.alternate_name.length > 100}
          helperText={
            piece.alternate_name.length > 100
              ? t('restaurant.info.equipment.lengthError')
              : ''
          }
        />
        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={localesMap[selectedLanguage]}>
          <DatePicker
            style={{ width: '300px', margin: '8px 8px 8px 9px' }}
            size="small"
            autoOk
            variant="inline"
            inputVariant="outlined"
            id={`equipment_purchase_date-${index}`}
            label={t('restaurant.info.equipment.purchaseDate')}
            format="yyyy-MM-dd"
            clearable
            disableFuture
            name={`equipment_purchase_date-${index}`}
            value={piece.equipment_purchase_date || null}
            onChange={(date: Date | null) => handleChange(date)}
            InputProps={{
              endAdornment: piece.equipment_purchase_date ? (
                <InputAdornment position="end">
                  <IconButton onClick={(e) => handleClr(e)}>
                    <ClearIcon />
                  </IconButton>
                </InputAdornment>
              ) : null

            }}
          />
        </MuiPickersUtilsProvider>
        <FormControl
          required
          className={classes.formControl}
          variant="outlined"
          size="small"
          style={{ width: '300px' }}
        >
          <InputLabel id="demo-simple-select-outlined-label">
            {t('restaurant.info.equipment.zone')}
          </InputLabel>
          <Select
            labelId="demo-simple-select-outlined-label"
            id="demo-simple-select-outlined"
            value={piece.restaurant_zone_id}
            onChange={handleChangeSelect}
            name={`restaurant_zone_id-${index}`}
          >
            <MenuItem value="0"></MenuItem>
            {zones.map(zone => (
              <MenuItem value={zone.id} key={zone.id}>{t(`equipment.zone.${textToSnakeCase(zone.name)}`, zone.name)}</MenuItem>
            ))}
          </Select>
        </FormControl>
        {brand === 'TH' && (
          <FormControl
            className={classes.formControl}
            variant="outlined"
            size="small"
            style={{ width: '300px' }}
          >
            <InputLabel id="demo-simple-select-outlined-label">
              {t('equipment.calibrationProfile')}
            </InputLabel>
            <Select
              labelId="demo-simple-select-outlined-label"
              id="demo-simple-select-outlined"
              value={
                piece.calibration_profile === null
                  ? ''
                  : piece.calibration_profile
              }
              onChange={handleChangeSelect}
              name={`calibration_profile-${index}`}
            >
              <MenuItem value=""></MenuItem>
              {calibrationProfiles.map(cp => (
                <MenuItem value={cp.id} key={cp.id}>
                  {cp.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
      </div>
      {removeOption && (
        <IconButton
          onClick={removeRow(index)}
          aria-label={t('app.common.delete')}
        >
          <CancelPresentationIcon />
        </IconButton>
      )}
    </div>
  );
};

export default SpecificDataRow;
